import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { WebLoaderComponent } from './web-loader/web-loader.component';
import { ImageViewComponent } from './image-view/image-view.component';
import { MapViewComponent } from './map-view/map-view.component';
import { SafePipe } from './SafePipe';
import { ReportFraudsComponent } from './report-frauds/report-frauds.component';
import { ReferralModalComponent } from './referral-modal/referral-modal.component';
import { InstallModalComponent } from './install-modal/install-modal.component';
import { ExperienceModalComponent } from './experience-modal/experience-modal.component';

@NgModule({
  declarations: [WebLoaderComponent, ImageViewComponent, MapViewComponent, SafePipe, ReportFraudsComponent, ReferralModalComponent, InstallModalComponent, ExperienceModalComponent],
  imports: [
    CommonModule, FormsModule, ReactiveFormsModule
  ],
  exports: [WebLoaderComponent, ImageViewComponent, MapViewComponent, SafePipe, 
    ReferralModalComponent, InstallModalComponent, ExperienceModalComponent, ReportFraudsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UtilityModule { }
